'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var STEP = exports.STEP = 'STEP';
var SET_RETURN = exports.SET_RETURN = 'SET_RETURN';
var REDUCE_STEP = exports.REDUCE_STEP = 'REDUCE_STEP';
var REDUCE_STAGES = exports.REDUCE_STAGES = 'REDUCE_STAGES';
var REDUCE_RETURNS = exports.REDUCE_RETURNS = 'REDUCE_RETURNS';
var REDUCE_RETURN = exports.REDUCE_RETURN = 'REDUCE_RETURN';
var REDUCE_RETURN_ELEMENT = exports.REDUCE_RETURN_ELEMENT = 'REDUCE_RETURN_ELEMENT';
var REDUCE_RETURN_DEEP = exports.REDUCE_RETURN_DEEP = 'REDUCE_RETURN_DEEP';
var REDUCE_ENTITY = exports.REDUCE_ENTITY = 'REDUCE_ENTITY';
var REDUCE_DYNAMIC_DATE = exports.REDUCE_DYNAMIC_DATE = 'REDUCE_DYNAMIC_DATE';
var REDUCE_VALID = exports.REDUCE_VALID = 'REDUCE_VALID';
var REDUCE_CONTROL = exports.REDUCE_CONTROL = 'REDUCE_CONTROL';
var REDUCE_ANONYMOUS = exports.REDUCE_ANONYMOUS = 'REDUCE_ANONYMOUS';
var REDUCE_TABLE_RETURN = exports.REDUCE_TABLE_RETURN = 'REDUCE_TABLE_RETURN';
var EXECUTE_ACTION = exports.EXECUTE_ACTION = 'EXECUTE_ACTION';
var REDUCE_STEP_ANALYTICS = exports.REDUCE_STEP_ANALYTICS = 'REDUCE_STEP_ANALYTICS';
var GET_WORKFLOW_CONFIGURATION = exports.GET_WORKFLOW_CONFIGURATION = 'GET_WORKFLOW_CONFIGURATION';
var REDUCE_WORKFLOW_CONFIGURATION = exports.REDUCE_WORKFLOW_CONFIGURATION = 'REDUCE_WORKFLOW_CONFIGURATION';